import { AxiosError } from "axios";
import { useEffect, useState } from "react";
import useSWR from "swr";
import { GetFunding200Response } from "../../../codegen-api";
import { APIEndpointEnum } from "../../../enums/endpoint";
import { publicApi } from "../../../services/api/apiFetcher";
import {
  pollingDelay,
  pollingInterval,
} from "../../../services/api/pollingInterval";

export const useFunding = (instrumentName?: string) => {
  const fetcher = publicApi();
  const delay = pollingDelay[APIEndpointEnum.FUNDING];
  const [startsQuery, setStartsQuery] = useState(!delay);

  useEffect(() => {
    if (!delay) return;
    // Wait before querying
    const t = setTimeout(() => {
      setStartsQuery(true);
    }, delay);
    return () => clearTimeout(t);
  }, [delay]);

  return useSWR<GetFunding200Response, AxiosError>(
    instrumentName && startsQuery
      ? [APIEndpointEnum.FUNDING, instrumentName]
      : undefined,
    async () => (await (await fetcher.getFunding(instrumentName!))()).data,
    {
      refreshInterval: pollingInterval[APIEndpointEnum.FUNDING],
      // Collapse duplicate/staggered-mount fetches across consumers.
      // Kept below the 15s poll so freshness is unchanged.
      dedupingInterval: 5000,
    }
  );
};
